// curl -X GET "https://oudw596oe3.execute-api.us-west-2.amazonaws.com/dev/flight?airline=AS&date=20180925&flightno=2801&airport=SEA" -H "accept: application/json" -H "Content-Type: application/json" -H "Accept: application/json" -H "x-api-key: yG688vhxLH2Zht6G0TNN09k6I5sfUUki1vmRbgcF"
export const carkclint = {
  data: function () {
    return {
      flightInfo: '',
      inProgress: false
    }
  },
  methods: {
    formatMonthOrDay: function (num) {
      var str = String(num)
      if (str.length === 1) {
        return '0' + str
      } else {
        return str
      }
    },
    verifyFlight: function (date, airline, flightNumber, airport) {
      var v = this

      var dateObj = new Date(date)
      var formattedDate = encodeURIComponent('' + dateObj.getFullYear() + this.formatMonthOrDay(dateObj.getMonth() + 1) + this.formatMonthOrDay(dateObj.getDate()))
      var formattedAirline = encodeURIComponent(airline)
      var formattedFlightNumber = encodeURIComponent(flightNumber)
      var formattedAirport = encodeURIComponent(airport)

      var host = 'https://k8s.hacksy-do.com/carkclint'
      var path = '/v1/flight?airline=' + formattedAirline + '&date=' + formattedDate + '&flightno=' + formattedFlightNumber + '&airport=' + formattedAirport

      $.ajax({
        url: host + path,
        type: 'GET',
        dataType: 'json',
        headers: {
          Accept: 'application/json; charset=utf-8',
          'Content-Type': 'application/json; charset=utf-8'
        },
        beforeSend: function (xhr) {
          v.inProgress = true
          v.$emit('flightConfirmationInProgress', v.inProgress)
        },
        error: function (e) {
          v.$emit('flightConfirmationReceived', { status: 'ERROR' })
        },
        success: function (data) {
          console.log(data)
          v.quote = data
          v.$emit('flightConfirmationReceived', v.quote)
        },
        complete: function () {
          v.inProgress = false
          v.$emit('flightConfirmationInProgress', v.inProgress)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/clients/carkclint.js